import { store } from "../../../store/front_end_data_base/store";

const API_BASE = (
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_SERVER_SCRIPT_HOST ||
  "http://localhost:5000/api/v1/universe-inventory"
).replace(/\/+$/, "");

const appUrl = (slug) => `${API_BASE}/applications/${encodeURIComponent(slug)}`;

const readJson = async (response) => {
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(payload.message || "Application service is unavailable.");
    error.status = response.status;
    error.code = payload.code;
    throw error;
  }
  return payload;
};

export async function fetchApplications() {
  const response = await fetch(`${API_BASE}/applications`);
  return (await readJson(response)).applications || [];
}

export async function fetchApplication(slug) {
  const response = await fetch(appUrl(slug));
  return (await readJson(response)).application;
}

export async function fetchApplicationReleases(slug) {
  const response = await fetch(`${appUrl(slug)}/releases`);
  return (await readJson(response)).releases || [];
}

export async function downloadApplication(slug, category = "CLIENT") {
  const url = `${appUrl(slug)}/download`;
  if (category !== "STAFF") {
    // Native browser download, without buffering large APKs into a JavaScript Blob.
    const link = document.createElement("a");
    link.href = url;
    link.rel = "noopener";
    document.body.appendChild(link);
    link.click();
    link.remove();
    return;
  }

  // Restricted releases require an existing verified staff session, not arbitrary text access tokens.
  const token = store.getState()?.universeStaffs?.sessionToken;
  if (!token) throw new Error("Sign in as authorized Universe staff to download this application.");
  const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
  if (!response.ok) await readJson(response);
  const blob = await response.blob();
  const objectUrl = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = `${slug}.apk`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
}
